import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import * as S from './styles';

import api from '../../services/api';

import { useToast } from '../../hooks/ToastContext';

import Header from '../../components/Header';
import Label from '../../components/Label';

const RegisterOportunity: React.FC = () => {

	const [loading] = useState(false);
	const [locale, setLocale] = useState<string>();
	// const [city, setCity] = useState<string>();
	// const [state, setState] = useState<string>();
	const [description, setDescripton] = useState<string>();
	const [requirements, setRequirements] = useState<string>();
	const [benefits, setBenefits] = useState<string>();
	const [attributes, setAttributes] = useState<string>();

	const { addToast } = useToast();
	const history = useHistory();

	function handleOpportunity() {

		const stateAndCity = locale?.split('-');

		api.post('v1/oportunity', {
			description,
			city: stateAndCity ? stateAndCity[0] : '',
			state: stateAndCity ? stateAndCity[1] : '',
			attributes,
			requirements,
			benefits,
			status: 1
		}).then(response => {
			if (response.status === 201) {
				addToast({
					type: 'success',
					title: 'Vaga cadastrada com sucesso'
				});
				history.push('/opportunities');
			}
		});
	}

	return (
		<S.Container>
			<Header />
			<S.Content>
				<S.ContentTitle>
					<S.Title>Cadastro de oportunidade</S.Title>
					<S.LineHorizontal />
				</S.ContentTitle>

				<S.ContentForm>
					<S.RowForm>
						<S.Col grid={6}>
							<S.ContentInput>
								<Label>Vaga:</Label>
								<S.InputText
									type="text"
									placeholder="Digite o nome da vaga"
									onChange={e => setDescripton(e.target.value)}
								/>
							</S.ContentInput>
						</S.Col>
						<S.Col grid={3}>
							<S.ContentInput>
								<Label>Local da vaga:</Label>
								<S.Select onChange={e => setLocale(e.target.value)}>
									<S.Option value={Number(0)} disabled selected>Selecione</S.Option>
									<S.Option value="Goiânia - GO">Goiânia - GO</S.Option>
									<S.Option value="Anápolis - GO">Anápolis - GO</S.Option>
								</S.Select>
							</S.ContentInput>
						</S.Col>

						{/* <S.Col grid={3}>
							<S.ContentInput>
								<Label>Status da vaga:</Label>
								<S.Select onChange={e => setStatus(e.target.value)}>
									<S.Option value={Number(0)} disabled selected>Selecione</S.Option>
									<S.Option value="active">Disponível</S.Option>
									<S.Option value="inactive">Indisponível</S.Option>
								</S.Select>
							</S.ContentInput>
						</S.Col> */}
					</S.RowForm>

					<S.RowForm>
						<S.Col grid={12}>
							<S.ContentInput>
								<Label>Descrição:</Label>
								<S.TextArea
									placeholder="Digite a descrição da vaga"
									onChange={e => setAttributes(e.target.value)}
								/>
							</S.ContentInput>
						</S.Col>
					</S.RowForm>

					<S.RowForm>
						<S.Col grid={12}>
							<S.ContentInput>
								<Label>Requisitos:</Label>
								<S.TextArea
									placeholder="Digite os requisitos da vaga"
									onChange={e => setRequirements(e.target.value)}
								/>
							</S.ContentInput>
						</S.Col>
					</S.RowForm>

					<S.RowForm>
						<S.Col grid={12}>
							<S.ContentInput>
								<Label>Benefícios:</Label>
								<S.TextArea
									placeholder="Digite os benefícios da vaga"
									onChange={e => setBenefits(e.target.value)}
								/>
							</S.ContentInput>
						</S.Col>
					</S.RowForm>
				</S.ContentForm>

				<S.ContentButtons>
					<S.ButtonNextOrSave
						loading={loading}
						onClick={handleOpportunity}
					>Cadastrar</S.ButtonNextOrSave>
				</S.ContentButtons>
			</S.Content>
		</S.Container>
	);
}

export default RegisterOportunity;